import { createContext, useContext, useState } from 'react'

import type { UpdateStrategyDialogProps } from './dialogs/UpdateStrategyDialog'

type StrategyAction = { type: 'create' } | { type: 'update'; params: UpdateStrategyDialogProps['strategy'] }

type ActionParams<T extends StrategyAction['type']> =
  Extract<StrategyAction, { type: T }> extends { params: infer P } ? P : never

export const useCreateStrategyActionsContext = () => {
  const [actionState, setActionState] = useState<StrategyAction | null>(null)

  return {
    actionState,
    openCreate: () => setActionState((current) => current ?? { type: 'create' }),
    openUpdate: (params: ActionParams<'update'>) =>
      setActionState((current) => current ?? { type: 'update', params: { ...params } }),
    close: () => setActionState(null),
  }
}

export const StrategyActionsContext = createContext<ReturnType<typeof useCreateStrategyActionsContext> | null>(null)

export const useStrategyActions = () => {
  const context = useContext(StrategyActionsContext)
  if (!context) {
    throw new Error('useStrategyActions requires StrategyActionsProvider')
  }

  return context
}
